import React from 'react'
import DescriptionEditor from './DescriptionEditor/DescriptionEditor'

/** Task description: mentions on, story/step links off */
const TaskDescriptionEditor = (props) => (
    <DescriptionEditor
        {...props}
        enableMentions={props.enableMentions ?? true}
        enableAppLinks={props.enableAppLinks ?? false}
    />
)

export default TaskDescriptionEditor
